<template>
    <div id="ref">
        <section class="section s-referals reg">
            <div class="container">
                <div class="referal_header">
                    <h1>Оплата</h1>
                    <h3>Оплатите 350 рублей онлайн с любого банка по QR-коду.</h3>
                </div>
                <div class="referal_description">
                    <img src="/static/img/code.png" alt="">
                    <h3>Оплатите 350 рублей онлайн с любого банка по QR-коду. Сканируйте его в Сбербанке Онлайн или в другом онлайн банке.</h3>
                    <h3>Или оплатите через яндекс деньги:</h3>
                    <iframe data-v-c43d8b78="" src="https://money.yandex.ru/quickpay/button-widget?targets=%D0%9E%D0%BF%D0%BB%D0%B0%D1%82%D0%B0%20%D0%B7%D0%B0%20%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%B2%D0%BE%D0%B7%D0%B2%D1%80%D0%B0%D1%82%D1%83%20%D0%BF%D1%80%D0%B0%D0%B2&amp;default-sum=350&amp;button-text=11&amp;yamoney-payment-type=on&amp;button-size=m&amp;button-color=orange&amp;successURL=&amp;quickpay=small&amp;account=4100110863551029" width="184" height="36" frameborder="0" allowtransparency="true" scrolling="no"></iframe>
                    <div data-v-c43d8b78="" class="promo_form">
                        <input data-v-c43d8b78="" type="text" placeholder="Введите промо-код">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
  name: 'pay',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pay.vue